module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Ha-Ic.6fb35fdb.png";